module.exports = __webpack_public_path__ + "img/ministries_banner.3c7ab975.jpg";